/**
 * Image caption width.
 * @type {{attach: Drupal.behaviors.imageCaption.attach}}
 */
const $ = window.jQuery;

export default {
  attach: function (context, settings) {
    const imageCaption_once = once('image-caption-once', '.paragraph.text .paragraph__content figure', context);

    $(imageCaption_once).each(function () {
      if ($(this).find('> .embedded-entity img') && $(this).find('> figcaption')) {
        let image = $(this).find('> .embedded-entity img');
        setTimeout(function() {
          let imageWidth = image.width();
          let imageCaption = image.closest('figure').find('> figcaption');
          imageCaption.css('width', imageWidth);
        }, 1000);
      }
    });
  },
}
